// @flow
import { ACTIONS_NAMESPACE as CB_ACTIONS_NAMESPACE } from '../constants';

export const MOUNT_POINT = 'networks';

export const ACTIONS_NAMESPACE = `${CB_ACTIONS_NAMESPACE}/NETWORKS`;

export const SWITCH_COORDINATE_SYSTEM = `${ACTIONS_NAMESPACE}/SWITCH_COORDINATE_SYSTEM`;

export const POINTS_WITH_CABLE_RESERVE_DISPLAY = [
    'shaft',
    'wallpoint',
    'pop',
    'pillar',
];
